<template>
    <div class="flex flex-col max-w-screen-xl mx-auto px-4 sm:px-6 md:px-8 lg:px-32">
        <!-- Hero -->
        <div class="flex flex-row justify-center items-center m-8 gap-x-8">
            <span
                class="!w-24 h-16 fi drop-shadow"
                :class="`fi-${packages[0]?.countryCode.toLowerCase()}`"></span>
            <h2 class="text-3xl text-san-marino-700">{{ packages[0]?.country }}</h2>
        </div>
        <h1 class="text-2xl text-san-marino-700 text-center mb-6">{{ packages[0]?.country }} tatilinde kesintisiz internet için eSIM kullan! SIM kart değiştirmeden anında bağlan, {{ packages[0]?.country }} eSIM'i ile her an bağlantıda kal.</h1>
        <!-- Packages -->
        <div class="flex flex-wrap mb-12">
            <div
                v-for="item in packages"
                :key="item.id"
                class="flex flex-col w-full md:w-1/2 lg:w-1/3 p-4">
                <div
                    :class="`flex flex-col rounded-lg shadow-lg bg-gradient-to-r from-[color:var(--from)] to-[color:var(--to)] text-white divide-y`"
                    :style="{
                        '--from': item.gradientStart,
                        '--to': item.gradientEnd,
                    }">
                    <div class="text-lg font-semibold px-4 py-6">
                        {{ item.title }}
                    </div>
                    <div
                        class="flex justify-between items-center text-md font-semibold p-4">
                        <span class="text-xs">KAPSAMA ALANI</span>
                        <span class="truncate">{{ item.country }}</span>
                    </div>
                    <div
                        class="flex justify-between items-center text-md font-semibold p-4">
                        <span class="text-xs">VERİ</span>
                        {{ item.data }}
                    </div>
                    <div
                        class="flex justify-between items-center text-md font-semibold p-4">
                        <span class="text-xs">GEÇERLİLİK</span>
                        {{ item.days }}
                    </div>
                    <div
                        class="flex justify-between items-center text-md font-semibold p-4">
                        <span class="text-xs">FİYAT</span>
                        <span class="text-xl">{{ item.price }}</span>
                    </div>
                    <div class="text-lg font-semibold px-4 py-6">
                        <NuxtLink :to="config.baseUrl + '/checkout/' + item.id + '?cancel_url=' + route.path + (promotekit_referral ? '&via=' + promotekit_referral : '')">
                            <div
                                class="flex justify-center items-center h-full text-xs w-full rounded border px-2 py-3 hover:bg-white hover:text-black">
                                HEMEN SATIN AL
                            </div>
                        </NuxtLink>
                    </div>
                </div>
            </div>
        </div>
        <!-- How to works -->
        <HowToWorks />
        <!-- Compatible Devices -->
        <CompatibleDevices />
        <!-- Content -->
        <div class="text-san-marino-700 my-6" v-html="contents.content" v-if="contents.content">
        </div>
        <!-- Content related tailwind classes -->
        <div class="my-4 ml-4 list-disc list-decimal list-inside hidden"></div>
        <!-- Frequently Asked Questions -->
        <FrequentlyAskedQuestions />
    </div>
</template>

<script setup>
const route = useRoute();
const config = useSanctumConfig();
const client = useSanctumClient();
const promotekit_referral = useCookie("promotekit_referral");

const {
    data: packages,
} = await useAsyncData("packages", () =>
    client("/packages/" + route.params.country.toLowerCase())
);

const {
    data: contents,
} = await useAsyncData("contents", () =>
    client("/contents/" + route.params.country.toLowerCase())
);

const country = packages.value[0]?.country;
const price = packages.value[0]?.price;

const keywords = country + " eSIM, " + country + " wifi, " + country + " mobil veri planı";
const title = country + " eSIM'i, " + price + " başlayan fiyatlarla";
const description = country + " tatilinde kesintisiz internet için eSIM kullan! SIM kart değiştirmeden anında bağlan, " + country + " eSIM'i ile her an bağlantıda kal.";

useHead({
    title: title,
    meta: [
        {
            name: "description",
            content: description,
        },
        {
            name: "keywords",
            content: keywords,
        }
    ],
});
</script>